import React from "react";
import renameimg from "../../assets/images/rename.svg";
import Product from "../../assets/images/Image 2.png";

const ProductSummary = () => {
  return (
    <section>
      <div className="container-fluid">
        <div className="row product-summary-row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-2">
              <div className="card-body">
                <div className="row print-area-row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto">
                    <div className="d-flex">
                      <div>
                        <i class="fas fa-chevron-left"></i>
                      </div>
                      <div>
                        <h6>Product Details</h6>
                        <p>10 Results Found</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 my-auto">
                    <div className="d-flex justify-content-end">
                      <div className="text-align">
                        <button className="btn share-btn" type="button">
                          <span class="material-symbols-rounded">
                            share_windows
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="row product-list-summary-row">
              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 left-side-card">
                <div className="card">
                  <div className="card-header">
                    <h6>Product List</h6>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>
                        <img src={Product} />
                        <p>Mark 1</p>
                        {/* <p>
                          <input
                            type="text"
                            className="w-100"
                            name="txtmarkName"
                          ></input>
                        </p> */}
                        <div className="action-visible">
                          <div className="action-icons ml-2">
                            <span>
                              <img
                                src={renameimg}
                                alt="Rename"
                                title="Rename"
                                className="mr-1"
                              ></img>
                            </span>
                            <i
                              className="far fa-copy mr-1"
                              title="Duplicate"
                            ></i>
                            <i className="far fa-trash-alt" title="Delete"></i>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-8 col-sm-12 col-xs-12 right-side-card">
                <div className="card">
                  <div className="card-body pt-0 pr-0 pl-0">
                    <div className="table-responsive">
                      <table className="table table-borderless">
                        <thead>
                          <tr>
                            <th>Mark</th>
                            <th>Product Group</th>
                            <th>Product Model</th>
                            <th>Quantity</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Mark1</td>
                            <td>1.5 hour Rated Static Fire Damper</td>
                            <td>GModel - 119</td>
                            <td>15</td>
                            <td>
                              <i class="fas fa-chevron-right"></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductSummary;
